<template>
  <div class="iconBoxes">
    <div class="iconBoxes__inner">
      <!--      <SwiperSlider ref="productSlider" class="iconBoxes__list" :options="swiperOptions">-->
      <!--        <div v-for="(box, indexBox) in items" :key="indexBox" class="iconBoxes__slide swiper-slide">-->
      <!--          <component-->
      <!--            :is="box.to ? 'nuxt-link' : 'a'"-->
      <!--            :to="box.to"-->
      <!--            :href="box.href"-->
      <!--            class="iconBoxes__item"-->
      <!--          >-->
      <!--            <div class="iconBoxes__itemIcon">-->
      <!--              <img v-if="box.icon" :src="box.icon" alt="" :width="box.width" :height="box.height" />-->
      <!--            </div>-->
      <!--            <div class="iconBoxes__itemContent">-->
      <!--              <div class="iconBoxes__itemText" v-html="box.title" />-->
      <!--              <div class="iconBoxes__itemDesc" v-html="box.desc" />-->
      <!--            </div>-->
      <!--          </component>-->
      <!--        </div>-->
      <!--        <div slot="pagination" class="swiper-pagination" />-->
      <!--      </SwiperSlider>-->
      <div v-for="(box, indexBox) in items" :key="indexBox" class="iconBoxes__slide">
        <component
          :is="box.to ? 'nuxt-link' : 'a'"
          :to="box.to"
          :href="box.href"
          class="iconBoxes__item"
        >
          <div class="iconBoxes__itemIcon">
            <img v-if="box.icon" :src="box.icon" alt="" :width="box.width" :height="box.height" />
          </div>
          <div class="iconBoxes__itemContent">
            <div class="iconBoxes__itemText" v-html="box.title" />
            <div class="iconBoxes__itemDesc" v-html="box.desc" />
          </div>
        </component>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IconBoxes',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.iconBoxes {
  .swiper-pagination {
    bottom: 0;
  }

  &__list {
    position: relative;
    display: flex;
    width: 100%;

    @include rwd('small-laptop') {
      padding-bottom: 3rem;
    }
  }

  &__inner {
    display: flex;

    @include rwd('laptop') {
      flex-wrap: wrap;
    }
  }

  &__slide {
    display: flex;
    flex: 1;
    height: auto !important;
    border-left: 1px solid $cAddLight;
    background-color: $cWhite;

    @include rwd('laptop') {
      min-width: 25%;

      &:nth-child(4) {
        display: none;
      }
    }

    @include rwd('large-tablet') {
      min-width: 50%;

      &:nth-child(3) {
        border-top: 1px solid $cAddLight;
        border-left: 0;
      }

      &:nth-child(5) {
        border-top: 1px solid $cAddLight;
      }
    }

    @include rwd('large-phone') {
      min-width: 100%;

      &:nth-child(2) {
        border-top: 1px solid $cAddLight;
        border-left: 0;
      }

      &:last-child {
        border-left: 0;
      }
    }

    &:first-child {
      border-left: 0;
    }
  }

  &__item {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1;
    padding: 2.2rem 2rem 2.2rem 2rem;
    box-shadow: 0 10px 30px rgba(23, 25, 51, 0);
    transition: box-shadow $tr;

    @include rwd('large-laptop') {
      padding: 1.8rem 1.2rem 1.8rem 1.2rem;
    }

    @include rwd('laptop') {
      padding: 1.2rem;
    }

    @include rwd('tablet') {
      padding: 1.6rem;
    }

    //&:after {
    //  @include icomoon('small-arrow-right');
    //  position: absolute;
    //  right: 1.5rem;
    //  top: 50%;
    //  transform: translateY(-50%);
    //  color: $cAddNeutral;
    //  font-size: 8px;
    //
    //  @include rwd('tablet') {
    //    display: none;
    //  }
    //}

    &:hover {
      box-shadow: 0 10px 30px rgba(23, 25, 51, 0.05);
    }
  }

  &__itemContent {
    padding-left: 1.4rem;
  }

  &__itemText {
    margin-bottom: 0.5rem;
    font-size: 1.6rem;
    line-height: 1.8rem;
    font-weight: 600;

    @include rwd('large-laptop') {
      font-size: 1.4rem;
    }
  }

  &__itemDesc {
    font-size: 1.4rem;
    line-height: 1.8rem;

    @include rwd('large-laptop') {
      font-size: 1.3rem;
    }
  }

  &__itemIcon {
    @include rwd('large-tablet') {
      min-width: 6rem;
    }
    @include rwd('small-tablet') {
      min-width: 4.5rem;
      max-width: 4.5rem;

      img {
        width: 100%;
      }
    }
  }
}
</style>
